import { writable, type Writable } from 'svelte/store';

export const submissionFormIsVisible = writable(false);
export const submissionStore: Writable<Submission> = writable();
export const newSubmissionInputStore: Writable<SubmissionInput> = writable();
export const lockedObjectsWarningIsVisible = writable(false);
